import type { ViewId } from "src/redux/reducers/MosaicManagerReducer";

/**
 * Maps a content `fileType` (lowercased extension with a leading dot, e.g. ".pdf")
 * to the viewer window that can preview it.
 *
 * This is the single source of truth for "does a file get an in-app preview, and
 * which viewer opens it". Adding a new previewable type (image, text, email, ...)
 * is a one-line change here plus its viewer window.
 */
export const PREVIEW_VIEWER_BY_FILETYPE: Record<string, ViewId> = {
  ".pdf": "PDFViewerWindow",
  ".csv": "CSVViewerWindow",
  ".png": "ImageViewerWindow",
  ".jpg": "ImageViewerWindow",
  ".jpeg": "ImageViewerWindow",
  ".gif": "ImageViewerWindow",
  ".webp": "ImageViewerWindow",
  ".svg": "ImageViewerWindow",
  ".bmp": "ImageViewerWindow",
  ".txt": "TextViewerWindow",
  ".log": "TextViewerWindow",
  ".json": "TextViewerWindow",
  ".xml": "TextViewerWindow",
  ".md": "TextViewerWindow",
  ".eml": "EmailViewerWindow",
};

/**
 * @returns true if the given fileType can be previewed in-app.
 */
export const isPreviewable = (fileType?: string): boolean => {
  return !!fileType && fileType.toLowerCase() in PREVIEW_VIEWER_BY_FILETYPE;
};

/**
 * @returns the viewer window id for the given fileType, or undefined if it is not previewable.
 */
export const getPreviewViewId = (fileType?: string): ViewId | undefined => {
  if (!fileType) return undefined;
  return PREVIEW_VIEWER_BY_FILETYPE[fileType.toLowerCase()];
};
